import { TaskTemplateInputType } from '@/enum'
import type { IAnswerValue, ITaskTemplateInput } from '@/interfaces'
import AnswerValue from './AnswerValue'
import { DEFAULT_JOB_START_TIME, DEFAULT_TEMPLATE_INPUT_IS_OPTIONAL } from '@/utils/constants'
import ChecklistAnswerValue from './ChecklistAnswerValue'
import InputValue from './InputValue'

class TaskTemplateInput implements ITaskTemplateInput {
  recordId: string

  creatorId: string

  updaterId: string

  title: string

  description: string

  order: number

  completingEmployeeOrder: number | null

  isReadonly: boolean

  isOptional: boolean

  inputType: TaskTemplateInputType

  answers: IAnswerValue[]

  choiceOptions: { recordId: string; value: string }[]

  items?: InputValue[]

  isCompleted?: boolean

  constructor(input?: any, isGetRequest?: boolean) {
    this.recordId = input?.recordId
    this.creatorId = input?.creatorId
    this.updaterId = input?.updaterId
    this.title = input?.title
    this.description = input?.description
    this.order = input?.order
    this.completingEmployeeOrder = input?.completingEmployeeOrder
    this.isReadonly = !!input?.isReadonly
    this.isOptional =
      input?.isOptional ??
      ([TaskTemplateInputType.BOOLEAN, TaskTemplateInputType.CHECKLIST].includes(
        input?.inputType
      ) ||
        DEFAULT_TEMPLATE_INPUT_IS_OPTIONAL)
    this.inputType = input?.inputType
    this.isCompleted = input?.isCompleted
    if (input?.inputType === TaskTemplateInputType.CHECKLIST) {
      this.answers = input?.answers?.map((answer: any) => new ChecklistAnswerValue(answer)) ?? []
    } else if (input?.inputType === TaskTemplateInputType.TIME) {
      this.answers = input?.answers?.map((answer: any) => {
        const trimmedValue = answer.value?.split(':').slice(0, 2).join(':')
        return new AnswerValue({ ...answer, value: trimmedValue })
      }) ?? []
    } else {
      this.answers = input?.answers?.map((answer: any) => new AnswerValue(answer)) ?? []
    }
    if (isGetRequest && input?.inputType === TaskTemplateInputType.STRING && input?.isReadonly) {
      this.inputType = TaskTemplateInputType.LABEL
    } else if (
      !isGetRequest &&
      input?.inputType === TaskTemplateInputType.LABEL &&
      input?.isReadonly
    ) {
      this.inputType = TaskTemplateInputType.STRING
    }
    this.choiceOptions = []
    if (input?.inputType === TaskTemplateInputType.TIME && !this.answers.length) {
      this.answers = [new AnswerValue({ value: DEFAULT_JOB_START_TIME })]
    }
    if (
      [TaskTemplateInputType.SINGLE_CHOICE, TaskTemplateInputType.MULTI_CHOICE].includes(
        input?.inputType
      )
    ) {
      this.choiceOptions = input.choiceOptions?.map((item: any) => new InputValue(item)) ?? []
    }
    if (input?.inputType === TaskTemplateInputType.CHECKLIST) {
      this.items = input?.items?.map((item: any) => new InputValue(item)) ?? []
    }
  }
}

export default TaskTemplateInput
